import { isEmpty } from 'lodash'
import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { UPDATE_USER_INFO, ECOMMERCE_API } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'
import RadioButtonChecked from '../../assets/imgComponents/radioButtonChecked'
import RadioButtonUnchecked from '../../assets/imgComponents/radioButtonUnchecked'
import { v4 as uuidv4 } from 'uuid'

const BundleProductAddressModal = () => {
  const {
    userObj,
    setLoader,
    validateSessionCall,
    accountObj,
    bundleProductsModalData,
    setBundleProductsModalData,
  } = useContext(AppContext)
  const navigate = useNavigate()
  const isShippingChargesEnabled = accountObj?.od_resource_allowances?.is_shipping_charges_enabled

  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
    phone: '',
    default: true,
  })
  const [errorData, setErrorData] = useState({})

  const [modalType, setModalType] = useState('NEW')
  const [addresses, setAddresses] = useState([])
  const [selectedAddress, setSelectedAddress] = useState({})
  const [statesData, setStatesData] = useState([])
  // Animation state
  const [show, setShow] = useState(false)

  const [{ data: updateUserRes, loading: updateUserLoading }, updateUserCall] = useAxios(
    {},
    { manual: true },
  )

  const [{ data: shippingChargesInfo, loading: shippingChargesLoading }, shippingChargesCall] =
    useAxios(
      {
        url: ECOMMERCE_API + '/shipping-charges',
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(updateUserLoading || shippingChargesLoading)
  }, [updateUserLoading, shippingChargesLoading])

  useEffect(async () => {
    if (updateUserRes && updateUserRes.success) {
      await validateSessionCall()
      navigate(bundleProductsModalData)
      handleClose()
    }
  }, [updateUserRes])

  useEffect(() => {
    if (isShippingChargesEnabled) {
      shippingChargesCall()
    }
  }, [isShippingChargesEnabled])

  useEffect(() => {
    if (shippingChargesInfo && shippingChargesInfo.success && !isEmpty(shippingChargesInfo?.data)) {
      let tempStateData = []
      shippingChargesInfo?.data.forEach((element) => {
        tempStateData = [...tempStateData, ...element?.states]
      })

      setStatesData(tempStateData)
    }
  }, [shippingChargesInfo])

  useEffect(() => {
    if (!isEmpty(userObj?.eccom_address)) {
      setAddresses([...userObj.eccom_address])
      const defaultAddress = userObj.eccom_address.find((address) => address.default)
      setSelectedAddress({ ...defaultAddress })
      setModalType('EDIT')
    }
  }, [userObj])

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      setBundleProductsModalData({})
    }, 400)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setErrorData((prev) => ({
      ...prev,
      [name]: '',
    }))
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (formData.name.trim().length === 0) {
      isFormValid = false
      temp.name = `name cannot be empty!`
    }
    if (formData.address.trim().length === 0) {
      isFormValid = false
      temp.address = `address cannot be empty!`
    }
    if (formData.city.trim().length === 0) {
      isFormValid = false
      temp.city = `city cannot be empty!`
    }
    if (formData.state.trim().length === 0) {
      isFormValid = false
      temp.state = `state cannot be empty!`
    }
    if (formData.zipcode.trim().length === 0) {
      isFormValid = false
      temp.zipcode = `zipcode cannot be empty!`
    }
    if (formData.country.trim().length === 0) {
      isFormValid = false
      temp.country = `country cannot be empty!`
    }
    if (formData.phone.trim().length === 0) {
      isFormValid = false
      temp.phone = `phone cannot be empty!`
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const updateAddressCall = (addressArr) => {
    updateUserCall({
      url: UPDATE_USER_INFO + '?user_id=' + userObj._id,
      method: 'put',
      data: {
        eccom_address: addressArr,
      },
    })
  }

  const handleSubmit = (e) => {
    if (modalType === 'NEW') {
      e.preventDefault()
      if (!validateInfo()) return

      const addressWithId = {
        ...formData,
        id: uuidv4(),
        default: true,
      }
      const tempAddresses = [...addresses].map((addr) => ({ ...addr, default: false }))
      updateAddressCall([...tempAddresses, addressWithId])
    } else if (modalType === 'EDIT') {
      let tempAddresses = [...addresses]
      const index = tempAddresses.findIndex((addr) => addr.id === selectedAddress.id)

      if (index !== -1) {
        tempAddresses = tempAddresses.map((addr, idx) =>
          idx !== index ? { ...addr, default: false } : { ...addr, default: true },
        )

        updateAddressCall([...tempAddresses])
      }
    }
  }

  return (
    <div
      style={{
        backgroundColor: '#00000070',
        opacity: show ? 1 : 0,
        transition: 'opacity 0.4s ease',
      }}
      className="fixed inset-0 flex items-center justify-center z-50"
    >
      <div
        style={{
          color: '#e3e2e2',
          backgroundColor: '#1d2a39',
          transform: show ? 'scale(1)' : 'scale(0.9)',
          opacity: show ? 1 : 0,
          transition: 'all 0.4s ease',
          minHeight: '454.3px',
        }}
        className="rounded-[10px] w-11/12 md:w-9/12 lg:w-[514px] px-5 py-[18px] lg:px-16"
      >
        <p className="text-base text-white font-semibold">
          {modalType === 'NEW' ? 'Add a new address' : 'Select your delivery address'}
        </p>
        <p style={{ fontSize: '11px', color: '#e5e5e5' }} className=" mb-5">
          {modalType === 'NEW'
            ? 'Please enter your complete delivery address and contact details to ensure successful delivery of the merchandise included with your PPV Plan.'
            : 'Please select your delivery address to ensure successful delivery of the merchandise included with your PPV Plan.'}
        </p>
        {modalType === 'NEW' ? (
          <div className="flex flex-col gap-3">
            <input
              type="text"
              placeholder={errorData?.name ? errorData?.name : 'Full Name'}
              className="p-2 rounded bg-transparent border text-sm"
              value={formData.name}
              name="name"
              onChange={handleChange}
              style={{ border: `solid 0.5px ${errorData?.name ? 'red' : '#979797'} ` }}
            />
            <textarea
              placeholder={errorData?.address ? errorData?.address : 'Address (Area and Street)'}
              name="address"
              className="p-2 rounded bg-transparent border text-sm"
              style={{ border: `solid 0.5px ${errorData?.address ? 'red' : '#979797'} ` }}
              value={formData.address}
              onChange={handleChange}
            />
            <input
              type="text"
              name="city"
              placeholder={errorData?.city ? errorData?.city : 'City'}
              className="p-2 rounded bg-transparent border text-sm"
              style={{ border: `solid 0.5px ${errorData?.city ? 'red' : '#979797'} ` }}
              value={formData.city}
              onChange={handleChange}
            />
            {isShippingChargesEnabled ? (
              <select
                className="p-2 rounded bg-transparent border text-sm"
                name="state"
                style={{ border: `solid 0.5px ${errorData?.state ? 'red' : '#979797'} ` }}
                value={formData.state}
                onChange={handleChange}
              >
                <option value="" disabled selected>
                  Select State
                </option>
                {statesData.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                name="state"
                placeholder={errorData?.state ? errorData?.state : 'State'}
                className="p-2 rounded bg-transparent border text-sm"
                style={{ border: `solid 0.5px ${errorData?.state ? 'red' : '#979797'} ` }}
                value={formData.state}
                onChange={handleChange}
              />
            )}
            <input
              type="text"
              name="zipcode"
              placeholder={errorData?.zipcode ? errorData?.zipcode : 'Zip code/ Pin code'}
              className="p-2 rounded bg-transparent border text-sm"
              style={{ border: `solid 0.5px ${errorData?.zipcode ? 'red' : '#979797'} ` }}
              value={formData.zipcode}
              onChange={handleChange}
            />
            <input
              type="text"
              placeholder={errorData?.country ? errorData?.country : 'Country'}
              name="country"
              className="p-2 rounded bg-transparent border text-sm"
              style={{ border: `solid 0.5px ${errorData?.country ? 'red' : '#979797'} ` }}
              value={formData.country}
              onChange={handleChange}
            />
            <input
              type="number"
              placeholder={errorData?.phone ? errorData?.phone : 'Phone Number'}
              name="phone"
              className="p-2 rounded bg-transparent border text-sm "
              style={{ border: `solid 0.5px ${errorData?.phone ? 'red' : '#979797'} ` }}
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        ) : (
          <div style={{ height: '300px' }} className="flex flex-col gap-3 tv-epg-scrollbar-class">
            {addresses.map((address, index) => (
              <div
                key={index}
                className="flex cursor-pointer"
                onClick={() => setSelectedAddress(address)}
              >
                <div className="mt-1 ">
                  {address.id === selectedAddress?.id ? (
                    <RadioButtonChecked color={'#FF6301'} />
                  ) : (
                    <RadioButtonUnchecked />
                  )}
                </div>

                <div style={{ marginLeft: '10px', color: '#979797', fontSize: '12px' }}>
                  <p className="text-white font-bold">{address.name}</p>
                  <p>
                    {address.address}
                    {address.city}, {address.state} {address.zipcode}
                  </p>
                  <p>{address.country}</p>
                  <p>Phone Number : {address.phone}</p>
                </div>
              </div>
            ))}
            {modalType !== 'NEW' ? (
              <div
                style={{
                  color: '#e3e2e2',
                  fontSize: '12px',
                  border: '1px solid #ff6500',
                  height: '30px',
                  marginTop: '22px',
                }}
                className=" w-full py-1 rounded flex items-center justify-center cursor-pointer"
                onClick={() => setModalType('NEW')}
              >
                + Add New Address
              </div>
            ) : null}
          </div>
        )}

        <div style={{ marginBottom: '13px' }} className="flex mt-5 justify-end text-sm">
          <button
            type="button"
            className="px-6  rounded text-sm"
            style={{ border: '1px solid #f60', color: '#e3e2e2', height: '30px' }}
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6  rounded text-sm"
            style={{
              backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
              height: '30px',
              marginLeft: '30px',
            }}
            onClick={handleSubmit}
          >
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  )
}

export default BundleProductAddressModal
